// El interruptor de Configuración. Vivía adentro de `FuncionesAvanzadas`; se saca acá
// para que lo pueda usar también la card del formato de descarga
// (ADR-2026-09-14-el-formato-de-descarga-vive-en-funciones-avanzadas) sin que los dos
// archivos se importen en círculo. No cambió nada de su forma.

export function Interruptor({
  activo,
  onChange,
  disabled,
  etiqueta,
}: {
  activo: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  etiqueta: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={activo}
      aria-label={etiqueta}
      disabled={disabled}
      onClick={() => onChange(!activo)}
      // El anillo va con hex literal y no `ring-brand-primary/30`: Tailwind no
      // resuelve la opacidad sobre un color definido con var() y la clase no
      // llega al CSS (verificado contra dist/*.css).
      className={`shrink-0 relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1644EB4D] disabled:opacity-50 ${
        activo ? 'bg-brand-primary' : 'bg-neutral-300'
      }`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
          activo ? 'translate-x-5' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}

export default Interruptor;
